"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Evaporate = require("evaporate");
var MistBase_1 = require("./MistBase");
var Mist = (function (_super) {
    __extends(Mist, _super);
    function Mist(config, files) {
        var _this = _super.call(this, config, files) || this;
        Evaporate.create(config).then(function (evaporate) {
            _this.files.forEach(function (_a) {
                var file = _a.file, data = _a.data;
                var id = file.id;
                var name = data.path;
                var formattedConfig = {
                    name: name,
                    file: file,
                    progress: function (percentage) { return _this.onProgress(percentage, file.id); },
                    contentType: config.sendFileContentType ? file.type : undefined,
                };
                var cancel = function () { return evaporate.cancel(data.bucketName + "/" + data.path); };
                _this.onProgress(0, id);
                _this.onStart(cancel, id);
                evaporate.add(formattedConfig)
                    .then(function (awsObjectKey) { return _this.onSuccess(id, data, awsObjectKey); }, function (reason) { return _this.onError(reason, id); });
            });
        });
        return _this;
    }
    return Mist;
}(MistBase_1.default));
exports.default = Mist;
